export default function NotFound() {
    return (
        <div className="not_found">
            <h1>404 - Page Not Found</h1>
        </div>
    );
}
